import { useQuery } from '@tanstack/react-query';
import { industryApi } from '../api/industry';
import type { TradeRoute } from '../types';
// 定义查询参数类型
export interface TradeRouteQueryParams {
  year?: number;
  product_type?: string;
  origin_city?: string;
  destination_city?: string;
}

// 修复导入方式，通过 industryApi 对象调用方法
export const useTradeRoutes = (params?: TradeRouteQueryParams) => {
  return useQuery<TradeRoute[]>({
    queryKey: ['trade-routes', params],
    queryFn: () => industryApi.getTradeRoutes(params) as unknown as TradeRoute[],
  });
};